export default {
	//------------------------------------------------------------
	// Resources Types
	//------------------------------------------------------------


	//------------------------------------------------------------
	// Stoer Paths
	//------------------------------------------------------------


	//------------------------------------------------------------
	// Views
	//------------------------------------------------------------


	//------------------------------------------------------------
	// ACTIONS
	//------------------------------------------------------------
	AMD_SEO_CONTENTS_RENDER_ACTION: 'amd.seo.contents.render',
}